export default __webpack_public_path__ + "static/media/Deep waters2.52ca2d8d.jpg";